// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Filtergrowth_date_range_selection__BZ07e {
    color: #364e69;
    font-Weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/MileageSaarathiAce/GrowthTrackingTab_ace/Filter/Filtergrowth.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".date_range_selection {\n    color: #364e69;\n    font-Weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date_range_selection": `Filtergrowth_date_range_selection__BZ07e`
};
export default ___CSS_LOADER_EXPORT___;
